import { render, staticRenderFns } from "./createTypeReport.vue?vue&type=template&id=d3ec2ba4&"
import script from "./createTypeReport.vue?vue&type=script&lang=js&"
export * from "./createTypeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports